import { useTranslation } from 'react-i18next';

import { useTravelRequestSubmit } from '../model/TravelRequestQuery';
import { TravelRequestConfirmActionButton } from './TravelRequestConfirmActionButton';

interface TravelRequestSubmitButtonProps {
  requestId: number;
  disabled?: boolean;
  resubmit?: boolean;
  onError?: (error: Error) => void;
}

export function TravelRequestSubmitButton(props: TravelRequestSubmitButtonProps) {
  const { requestId, disabled, resubmit = false, onError } = props;
  const { t } = useTranslation();
  const submit = useTravelRequestSubmit(requestId);
  const mutate: typeof submit.mutate = (variables, options) =>
    submit.mutate(variables, {
      ...options,
      onError: (error, ...rest) => {
        onError?.(error);
        options?.onError?.(error, ...rest);
      },
    });
  const confirmKey = resubmit ? 'confirmResubmit' : 'confirmSubmit';

  return (
    <TravelRequestConfirmActionButton
      label={t('travel.requests.actions.submit')}
      confirmTitle={t(`travel.requests.actions.${confirmKey}.title`)}
      confirmContent={t(`travel.requests.actions.${confirmKey}.content`)}
      disabled={disabled}
      mutation={{ ...submit, mutate }}
    />
  );
}
